import { Button } from '@fox/atoms/src/button/index';
import { Icon } from '@fox/atoms/src/icon/index';
import { getExtension } from '@fox/extensions/src/extension-context';
import { useTheme } from 'styled-components';
import { useAutoDataGridContext } from '../../auto-data-grid/context';
import { FilterOperatorProps } from '../../contracts/FilterOperatorProps';
import { ChecklistPopover } from '../checklist/index';

export function HidePopover(columns: any) {
	const { hiddenColumnsDataIndex, setHiddenColumnsDataIndex, groupedColumns, allColumns } = useAutoDataGridContext();

	const theme = useTheme();

	// this code will take all the selections (individual columns) and consolidate the grouped columns into a single selection, to simplify the checkbox list
	const uniqueSelected = Array.from(
		new Set(
			hiddenColumnsDataIndex.map(a => {
				const c = allColumns.find(c => c.dataIndex == a);
				return c.groupTitle ?? c.dataIndex;
			})
		)
	);

	return (
		<ChecklistPopover
			options={Object.entries(groupedColumns).map(([idx, det]) => ({
				id: idx,
				title: det.title,
				icon: getExtension<FilterOperatorProps>(`column-operators-${det.filterType}`)?.icon
			}))}
			title={'Choose columns to hide'}
			disableLast={true}
			selected={uniqueSelected}
			onSelect={k =>
				// this will blow out the condensed selection into the full list of columns, outside this component we only deal with individual columns
				setHiddenColumnsDataIndex(allColumns.filter(f => k.includes(f.groupTitle) || k.includes(f.dataIndex)).map(a => a.dataIndex))
			}
		>
			<Button
				title="Hide column"
				style={{
					backgroundColor: hiddenColumnsDataIndex.length > 0 ? theme.colors.grey[200] : '',
					borderRadius: '35%/45%',
					minWidth: 'auto'
				}}
				sx={{
					'&:hover': {
						opacity: hiddenColumnsDataIndex.length > 0 ? '0.8 !important' : 'unset'
					}
				}}
			>
				<Icon iconName={'VisibilityOff'} sx={{ width: '20px', height: '20px' }} color="action" />
				{hiddenColumnsDataIndex.length > 0 ? <div style={{ marginLeft: '5px', marginRight: '2px' }}>{hiddenColumnsDataIndex.length}</div> : <></>}
			</Button>
		</ChecklistPopover>
	);
}
